import { Dialog, DialogActions, DialogContent } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import TreffasButton from "src/components/TreffasButton";

const RescheduleTimeLimitDialog = () => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={true} // parseInt(userReschedulableNotice) > parseInt(minutes_remaining)}
      onClose={() => console.log("Dialog cannot be close.")}
    >
      <DialogContent>
        {t("individual.booking.schedule.alert.booking_limit")}
      </DialogContent>
      <DialogActions>
        <TreffasButton
          variant="primary"
          size="md"
          onClick={() => (window.location.href = "https://treffas.com")}
          sx={{
            borderRadius: "12px",
            fontSize: "14px",
            minWidth: "100px",
          }}
        >
          {t("individual.booking.schedule.choose_schedule.button.close")}
        </TreffasButton>
      </DialogActions>
    </Dialog>
  );
};

export default RescheduleTimeLimitDialog;
